import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
// import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

// Components
import LandingPage from './components/landingPage/LandingPage';
import Login from './components/auth/Login';
import Layout from './components/layout/Layout';
import Dashboard from './components/dashboard/Dashboard';
import HousingData from './components/housing/HousingData';
import HousingForm from './components/housing/HousingForm';
import ScoringTable from './components/table/ScoringTable';
import AssessmentForm from './components/assessment/AssessmentForm';
import UserManagement from './components/admin/UserManagement';
import Profile from './components/profile/Profile';
import MapRTLH from './components/MapRTLH';
import MapView from './components/map/MapView';
import Reports from './components/reports/Reports';
import DatabaseManager from './components/database/DatabaseManager';
// import QuestionaryData from './components/questionary/QuestionaryData';
import QuestionsPage from './components/questions/QuestionsPage';
// import QuestionForm from './components/questions/QuestionForm';

// Context
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Services
import { checkAuthStatus } from './services/authService';

// Styles
import './App.css';

const AppRoutes = () => {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-spinner">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      {!isAuthenticated ? (
        <>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      ) : (
        <>
          {/* Kalau user sudah login, redirect "/" atau "/login" ke dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Navigate to="/dashboard" replace />} />

          {/* Protected routes inside Layout */}
          <Route element={<Layout />}>
            {/* Dashboard - All roles */}
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Map - Superadmin */}
            <Route
              path="/map/rtlh"
              element={
                ["superadmin"].includes(user?.role)
                  ? <MapRTLH />
                  : <Navigate to="/dashboard" replace />
              }
            />

            {/* Housing Data - Admin and Pengguna */}
            <Route
              path="/housing"
              element={
                ["admin", "pengguna"].includes(user?.role)
                  ? <HousingData />
                  : <Navigate to="/dashboard" replace />
              }
            />
            <Route
              path="/housing/add"
              element={
                ["admin", "pengguna"].includes(user?.role)
                  ? <HousingForm />
                  : <Navigate to="/dashboard" replace />
              }
            />
            <Route
              path="/housing/edit/:id"
              element={
                ["admin", "pengguna"].includes(user?.role)
                  ? <HousingForm />
                  : <Navigate to="/dashboard" replace />
              }
            />

            {/* Scoring Data - Admin and Pengguna */}
            <Route
              path="/scoring"
              element={
                ["admin", "pengguna"].includes(user?.role)
                  ? <ScoringTable />
                  : <Navigate to="/dashboard" replace />
              }
            />
            {/* <Route
              path="/scoring/add"
              element={
                ["admin", "pengguna"].includes(user?.role)
                  ? <ScoringForm />
                  : <Navigate to="/dashboard" replace />
              }
            />
            <Route
              path="/scoring/edit/:id"
              element={
                ["admin", "pengguna"].includes(user?.role)
                  ? <ScoringForm />
                  : <Navigate to="/dashboard" replace />
              }
            /> */}

            {/* Assessment - Admin and Pengguna */}
            <Route
              path="/assessment/:housingId"
              element={
                ["admin", "pengguna"].includes(user?.role)
                  ? <AssessmentForm />
                  : <Navigate to="/dashboard" replace />
              }
            />

            {/* Map View - All roles */}
            <Route path="/map" element={<MapView />} />

            {/* Reports - Admin and Peninjau */}
            <Route
              path="/reports"
              element={
                ["admin", "pengunjung"].includes(user?.role)
                  ? <Reports />
                  : <Navigate to="/dashboard" replace />
              }
            />

            {/* User Management - Admin only */}
            <Route
              path="/users"
              element={
                ["admin"].includes(user?.role)
                  ? <UserManagement />
                  : <Navigate to="/dashboard" replace />
              }
            />

            {/* Database Management - Admin only */}
            <Route
              path="/databases"
              element={
                ["admin"].includes(user?.role)
                  ? <DatabaseManager />
                  : <Navigate to="/dashboard" replace />
              }
            />

            {/* Questionary Management - Admin only */}
            {/* <Route
              path="/questionary"
              element={
                ["admin"].includes(user?.role)
                  ? <QuestionaryData />
                  : <Navigate to="/dashboard" replace />
              }
            /> */}

            {/* Questions Management - Admin only */}
            <Route
              path="/questions"
              element={
                ["admin"].includes(user?.role)
                  ? <QuestionsPage />
                  : <Navigate to="/dashboard" replace />
              }
            />

            {/* Profile - All roles */}
            <Route path="/profile" element={<Profile />} />

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </>
      )}
    </Routes>
  );
};

const App = () => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        // Check if user is already logged in
        const token = localStorage.getItem('token');
        if (token) {
          await checkAuthStatus();
        }
      } catch (error) {
        console.error('App initialization error:', error);
        localStorage.removeItem('token');
        toast.error('Sesi telah berakhir. Silakan login kembali.');
      } finally {
        setIsInitialized(true);
      }
    };

    initializeApp();
  }, []);

  if (!isInitialized) {
    return (
      <div className="loading-spinner">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
};

export default App; 